<div class="row">
  <app-form-field-display class="col-6" [formFieldConfig]="patientDataFields.gender"></app-form-field-display>
  <app-form-field-display *ngIf="patientDataFields.age" class="col-6" [formFieldConfig]="patientDataFields.age"></app-form-field-display>
  <app-form-field-display *ngIf="patientDataFields.dateOfBirth" class="col-6" [value]="dateOfBirthValue" [label]="dateOfBirthLabel" [infoText]="'analysisDateOfBirthAgeCalculatedInfo'"></app-form-field-display>
</div>
<div class="row">
  <app-form-field-display class="col-6" [formFieldConfig]="patientDataFields.height"></app-form-field-display>
  <app-form-field-display class="col-6" [formFieldConfig]="patientDataFields.weight"></app-form-field-display>
</div>
